import Popup from '../helpers/Popup';

;$(function() {

	$('.card-list input').click(function(e) {
		e.preventDefault();
	});

	$('.card-list button').click(function(e) {
		e.preventDefault();
	});

	$(document).on('click', '.card-list__list_favorite .quick-actions__button', function() {
		let _ = $(this);

		let carun = _.parents('ul').eq(0).data('carun');
		let action = _.data('action');

		setTimeout(function() {
			if (! _.hasClass('quick-actions__button_active'))
				$(document).find('main .card__quick-actions[data-carun="' + carun + '"] .quick-actions__button_active[data-action="' + action + '"]').removeClass('quick-actions__button_active');
			else
				$(document).find('main .card__quick-actions[data-carun="' + carun + '"] .quick-actions__button_active[data-action="' + action + '"]').addClass('quick-actions__button_active');

			if (action == 'fav') {
				_.parents('.card-list__item').fadeOut(400, function() {
					_.parents('.card-list__item').remove();
				});
			}
		}, 100);
	});

	$(document).on('dragstart','.card' , function () {
        return false;
    });

});